import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const boatGuide: Guide = {
  id: 'passeio-de-barco',
  imageTour: 'Passeio-em-aquamarina-ll',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: [
    'Passeio-em-aquamarina-ll',
    'saco-de-mamangua-lancha-rapida',
    'passeio-em-escuna-poseidon',
    'lancha-privada-madame',
  ],
  copy: {
    pt: {
      slug: 'passeio-de-barco-em-paraty',
      label: 'Passeio de barco em Paraty',
      title: 'Passeio de Barco em Paraty: Escuna, Lancha ou Privativo?',
      description: 'Como escolher seu passeio de barco em Paraty: escuna a partir de {price:Passeio-em-aquamarina-ll}, lancha ao Saco do Mamanguá ou lancha privativa. Roteiros, preços, horários e o que levar.',
    },
    es: {
      slug: 'paseo-en-barco-en-paraty',
      label: 'Paseo en barco en Paraty',
      title: 'Paseo en Barco en Paraty: ¿Barco, Lancha o Privado?',
      description: 'Cómo elegir tu paseo en barco en Paraty: barco desde {price:Passeio-em-aquamarina-ll}, lancha al Saco do Mamanguá o lancha privada. Rutas, precios, horarios y qué llevar.',
    },
    en: {
      slug: 'paraty-boat-tours',
      label: 'Paraty boat tours',
      title: 'Paraty Boat Tours: Schooner, Speedboat or Private?',
      description: 'How to choose a boat tour in Paraty: schooners from {price:Passeio-em-aquamarina-ll}, a speedboat to Saco do Mamanguá or a private boat. Routes, prices, times and what to bring.',
    },
    fr: {
      slug: 'excursion-en-bateau-a-paraty',
      label: 'Excursions en bateau à Paraty',
      title: 'Excursion en Bateau à Paraty : Goélette, Vedette ou Privé ?',
      description: 'Comment choisir son excursion en bateau à Paraty : goélette dès {price:Passeio-em-aquamarina-ll}, vedette vers le Saco do Mamanguá ou bateau privé. Itinéraires, prix, horaires et que prendre.',
    },
  },
};
